export function buildFirstLevelFilter(filter) {
  if (!filter) return [];
  const FIRST_LEVEL_FILTER = [
    "is_internal_driver",
    "active",
    "id",
    "first_name",
    "last_name",
    "email"
  ];

  const FILTER_VALUES = {
    is_internal_driver: "$eq",
    active: "$eq",
    id: "$cont",
    first_name: "$contL",
    last_name: "$contL",
    email: "$contL"
  };
  return Object.keys(filter)
    .filter(
      (field) =>
        FIRST_LEVEL_FILTER.includes(field) &&
        filter[field] !== undefined &&
        filter[field] !== null &&
        filter[field] !== ""
    )
    .map((filteredField) => {
      let value = filter[filteredField];
      return `${filteredField}||${FILTER_VALUES[filteredField]}||${value}`;
    });
}
